// extracted by mini-css-extract-plugin
module.exports = {"section":"RequestView_section__LP8rU","min-h":"RequestView_min-h__1OhvN","loading":"RequestView_loading__2wZ73"};